import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import {
  FaExclamationTriangle,
  FaClock,
  FaSpinner,
  FaCheckCircle
} from 'react-icons/fa';
import useLanguage from '../hooks/useLanguage';

const TaskStatistics = ({ statistics }) => {
  const { t } = useLanguage();

  const statCards = [
    {
      title: t('tasks.stats.critical'),
      value: statistics.critical || 0,
      icon: <FaExclamationTriangle />,
      color: '#dc3545',
      show: statistics.critical > 0
    },
    {
      title: t('tasks.stats.pending'),
      value: statistics.pending || 0,
      icon: <FaClock />,
      color: '#6c757d'
    },
    {
      title: t('tasks.stats.inProgress'),
      value: statistics.inProgress || 0,
      icon: <FaSpinner />,
      color: '#0dcaf0'
    },
    {
      title: t('tasks.stats.completed'),
      value: statistics.completed || 0,
      icon: <FaCheckCircle />,
      color: '#198754'
    }
  ];

  return (
    <Row className="mb-4 g-3">
      {statCards.filter(stat => stat.show !== false).map((stat, index) => (
        <Col key={index} xs={6} md={3}>
          <Card className="h-100 border-0 touch-card hm-tile">
            <Card.Body className="p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h2 className="mb-0" style={{ color: stat.color }}>{stat.value}</h2>
                  <small className="text-muted">{stat.title}</small>
                </div>
                <div className="fs-4" style={{ color: stat.color, opacity: 0.3 }}>
                  {stat.icon}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default TaskStatistics;
